var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransactionSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 36,
    viewBox: "0 0 66 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.45 31.7227C37.4757 32.6893 37.1177 33.6272 36.453 34.3342C36.0361 34.7796 35.5148 35.1168 34.9354 35.3145C34.3561 35.5122 33.7365 35.565 33.1317 35.4682C32.5269 35.3714 31.9555 35.1281 31.4681 34.7597C30.9807 34.3913 30.5923 33.9093 30.3375 33.3564C30.0827 32.8035 29.9692 32.1967 30.0072 31.5898C30.0451 30.983 30.2333 30.3948 30.5551 29.8773C30.8768 29.3599 31.3222 28.9293 31.8518 28.6236C32.3813 28.3178 32.9787 28.1465 33.5909 28.1247C33.6872 28.1203 33.7843 28.1203 33.8813 28.1247C33.9651 28.1276 34.0622 28.1356 34.1703 28.1487C34.3573 28.17 34.5458 28.1241 34.7018 28.0196L46 21L37.5566 31.2557C37.4728 31.3965 37.4355 31.5598 37.45 31.7227Z",
    fill: "#4F86C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 13.4991L17.5 4.99909C30.7 -2.60091 43.6667 1.83242 48.5 4.99909L43.5 13.4991C35.5 9.49909 26.1667 11.8324 22.5 13.4991Z",
    fill: "#FFA500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0017 14.5C14 18 10.0017 27.5 10.0017 33H0C0.4 18.2 10.8333 8.83333 16 6L21.0017 14.5Z",
    fill: "#FF2002"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9983 14.5C53 20 56.165 28.8333 55.9983 33H66C65.6 18.2 55.1667 8.83333 50 6L44.9983 14.5Z",
    fill: "#51DCA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionSuccess);
export default __webpack_public_path__ + "static/media/transactionSuccess.26b2a2b50954463c222ff86a70c834d4.svg";
export { ForwardRef as ReactComponent };